import { render } from "./CreditsBadge.vue?vue&type=template&id=a1cbbb12&scoped=true"
import script from "./CreditsBadge.vue?vue&type=script&lang=js"
export * from "./CreditsBadge.vue?vue&type=script&lang=js"

import "./CreditsBadge.vue?vue&type=style&index=0&id=a1cbbb12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1cbbb12"],['__file',"CreditsBadge.vue"]])

export default __exports__